import { AccountType, DtoBase, UserClass } from "..";
import { StorageRootDto } from "../StorageRootDto";


export class SessionDto extends StorageRootDto {

	private static readonly Default_AuthenticationType: AccountType = AccountType.Native;
	private static readonly Default_EffectiveUserClass: UserClass = UserClass.Observer;

	public AuthenticationType: AccountType;
	public UserGuid: string;
	public LastActivityTime: string;
	public EffectiveUserClass: UserClass;

	constructor() {
		super();

		this.AuthenticationType = SessionDto.Default_AuthenticationType;
		this.UserGuid = "";
		this.LastActivityTime = "";
		this.EffectiveUserClass = SessionDto.Default_EffectiveUserClass;
	}

	public get HasUserGuid(): boolean {
		return !!this.UserGuid;
	}

	public get HasLastActivityTime(): boolean {
		return !!this.LastActivityTime;
	}

	public Write(obj: any, context: any): void {
		obj.session = {};
		obj = obj.session;

		super.Write(obj, context);

		obj.authentication_type = AccountType[this.AuthenticationType];

		if (this.HasUserGuid)
			obj.user_guid = this.UserGuid;

		if (this.HasLastActivityTime)
			obj.last_activity_time = this.LastActivityTime;

		obj.effective_user_class = UserClass[this.EffectiveUserClass];
	}

	public Read(obj: any, context: any): void {

		if (!obj.session)
			throw new Error();
		obj = obj.session;

		super.Read(obj, context);

		if (obj.authentication_type !== undefined)
			this.AuthenticationType = AccountType[<string>obj.authentication_type];

		if (obj.user_guid !== undefined)
			this.UserGuid = obj.user_guid;

		if (obj.last_activity_time !== undefined)
			this.LastActivityTime = obj.last_activity_time;

		if (obj.effective_user_class !== undefined)
			this.EffectiveUserClass = UserClass[<string>obj.effective_user_class];
	}

}


export class SessionStateEntryDto extends DtoBase {

	public Key: string;
	public StringValue: string;

	constructor() {
		super();

		this.Key = "";
		this.StringValue = "";
	}

	public get HasKey(): boolean {
		return !!this.Key;
	}

	public get HasStringValue(): boolean {
		return !!this.StringValue;
	}

	public Write(obj: any, context: any): void {
		obj.session_state_entry = {};
		obj = obj.session_state_entry;

		super.Write(obj, context);

		if (this.HasKey)
			obj.key = this.Key;

		if (this.HasStringValue)
			obj.string_value = this.StringValue;
	}

	public Read(obj: any, context: any): void {

		if (!obj.session_state_entry)
			throw new Error();
		obj = obj.session_state_entry;

		super.Read(obj, context);

		if (obj.key !== undefined)
			this.Key = obj.key;

		if (obj.string_value !== undefined)
			this.StringValue = obj.string_value;
	}

}